import React from 'react';
import { motion } from 'framer-motion';

/**
 * Antigravity Effect - Inspired by react-bits
 * Creates floating particles that defy gravity around the children
 */
export const Antigravity = ({ children, particleCount = 12, className = "" }) => {
  return (
    <div className={`relative inline-block ${className}`}>
      {children}
      
      {/* Floating particles */}
      <div className="absolute inset-0 pointer-events-none overflow-visible">
        {[...Array(particleCount)].map((_, i) => {
          const angle = (i / particleCount) * Math.PI * 2;
          const radius = 60 + Math.random() * 40;
          const x = Math.cos(angle) * radius;
          const y = Math.sin(angle) * radius;
          const delay = i * 0.15;
          
          return (
            <motion.div
              key={i}
              className="absolute w-1.5 h-1.5 rounded-full bg-gradient-to-r from-yellow-400 via-orange-500 to-pink-500 blur-[1px]"
              style={{
                left: '50%',
                top: '50%',
              }}
              animate={{
                x: [0, x, x * 1.2, x, 0],
                y: [0, y, y * 1.2, y, 0],
                scale: [0, 1, 1.5, 1, 0],
                opacity: [0, 0.8, 1, 0.8, 0],
              }}
              transition={{
                duration: 4 + Math.random() * 2,
                repeat: Infinity,
                delay: delay,
                ease: "easeInOut",
              }}
            />
          );
        })}
      </div>
    </div>
  );
};
